function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.643 7.87L3.52 4.749 4.748 3.52l3.123 3.123 3.36-3.36 1.38 1.38-3.36 3.36 3.122 3.123-1.227 1.227-3.123-3.122-3.36 3.36-1.38-1.38 3.36-3.36z",
  fill: "currentColor"
});

function SvgIconNo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNjQzMDIgNy44NzA1NUwzLjUyMDQzIDQuNzQ3OTdMNC43NDc5NyAzLjUyMDQzTDcuODcwNTUgNi42NDMwMkwxMS4yMzA3IDMuMjgyODRMMTIuNjExIDQuNjYzMTJMOS4yNTA4MyA4LjAyMzI5TDEyLjM3MzQgMTEuMTQ1OUwxMS4xNDU5IDEyLjM3MzRMOC4wMjMyOSA5LjI1MDgzTDQuNjYzMTIgMTIuNjExTDMuMjgyODQgMTEuMjMwN0w2LjY0MzAyIDcuODcwNTVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgIconNo as ReactComponent };